import React from 'react';
import bitdefenderIcon from '../../../../assets/img/desktop/Bitdefender Antivirus.png';
import sophosIcon from '../../../../assets/img/desktop/sophos-logo-sup.png';
import kasperskyIcon from '../../../../assets/img/desktop/Kaspersky Antivirus.png';
import bitdefenderLogo from '../../../../assets/img/desktop/bitdefender-logo.png';
import sophosLogo from '../../../../assets/img/desktop/sophos-logo-inf.png';
import kasperskyLogo from '../../../../assets/img/desktop/kaspersky-logo.png';
import './CMEndpointProtection.css';

function CMEndpointProtection() {

    return (
        <main id="CMEndpointProtection">
            <section id="CMEP-c1">
                <h2>Endpoint Protection</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Ciberseguridad</li>
                    <li>/</li>
                    <li>Endpoint Protection</li>
                </ul>
            </section>
            <section id="CMEP-c2">
                <div id="CMEP-c2__text">
                    <h1>Protección de Endpoints para Empresas</h1>
                    <p>Las empresas pueden perder hasta el 70% de su valor por ataques cibernéticos. Y 80% de estos ataques provienen dentro de la empresa. Proteja sus dispositivos con soluciones líderes en el mercado.</p>
                </div>
            </section>
            <section id="CMEP-c3">
                <div className="CMEP-service-card">
                    <div className="CMEP-service-card__icon">
                        <img src={bitdefenderIcon} alt="Bitdefender Icon" />
                    </div>
                    <h3>Bitdefender</h3>
                    <p>Bitdefender GravityZone Business Security Premium ofrece protección de endpoints de última generación, combinando más de treinta tecnologías de seguridad basadas en aprendizaje automático. Esta solución proporciona múltiples capas de defensa contra amenazas sofisticadas, incluyendo ataques persistentes avanzados (APTs) y ransomware.</p>
                    <div className="CMEP-service-card__logo">
                        <img src={bitdefenderLogo} alt="Bitdefender Logo" />
                    </div>
                </div>
                <div className="CMEP-service-card">
                    <div className="CMEP-service-card__icon">
                        <img src={sophosIcon} alt="Sophos Icon" />
                    </div>
                    <h3>Sophos</h3>
                    <p>Sophos Endpoint, impulsado por Intercept X, adopta un enfoque integral de la seguridad que prioriza la prevención y bloquea las amenazas sin depender de una única técnica. Utiliza múltiples modelos de IA con aprendizaje profundo para proteger contra ataques conocidos y desconocidos.</p>
                    <div className="CMEP-service-card__logo">
                        <img src={sophosLogo} alt="Sophos Logo" />
                    </div>
                </div>
                <div className="CMEP-service-card">
                    <div className="CMEP-service-card__icon">
                        <img src={kasperskyIcon} alt="Kaspersky Icon" />
                    </div>
                    <h3>Kaspersky</h3>
                    <p>Kaspersky Endpoint Security for Business ofrece prevención automática contra el ransomware, la principal amenaza para las empresas. Su método de protección multicapas se basa en tecnologías que emplean aprendizaje automático e inteligencia sobre amenazas globales.</p>
                    <div className="CMEP-service-card__logo">
                        <img src={kasperskyLogo} alt="Kaspersky Logo" />
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CMEndpointProtection;

